module.exports = __webpack_public_path__ + "img/home_report.b3861d71.png";